import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ApplicationPathConstants } from '@ddt-web/config';
import { InjectConfig, ModelsExperienceConfigKey } from '@ddt-web/config-layer';
import { ComponentData } from '@ddt-web/data-service';
import { SharedApplicationConstants } from '@ddt-web/domain';
import { ApplicationStateStoreProxyService, PerformanceState } from '@ddt-web/shared-stores';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import * as get from 'lodash/get';
import * as isEmpty from 'lodash/isEmpty';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { ModelListRow, ModelsExperienceFilters } from '../../models';
import { ModelsBrowseDataService } from '../../services';

@UntilDestroy()
@Component({
	selector: 'mb-model-list-container',
	templateUrl: './model-list-container.component.html',
	styleUrls: ['./model-list-container.component.scss']
})
export class ModelListContainerComponent implements OnInit {
	@InjectConfig(ModelsExperienceConfigKey.SHOW_MODEL_LIST_DISCLOSURE) public readonly showModelListDisclosure: boolean = true;
	@InjectConfig(ModelsExperienceConfigKey.SHOW_FAMILY_LIST_HEADER_DISCLOSURE) public readonly showFamilyListHeaderDisclosure: boolean = true;
	@InjectConfig(ModelsExperienceConfigKey.SHOW_MODEL_LIST_PERFORMANCE_DISCLOSURE) public readonly showModelListPerformanceDisclosure: boolean = false;

	@InjectConfig(ModelsExperienceConfigKey.PERFORMANCE_BOX_DISCLOSURE_ENABLED_FOR_BLK_GROUP_FAMILY)
	public readonly performanceBoxDisclosureEnabledBlkFamilies: Array<string> = [];

	@Input() public data: ComponentData;
	@Input() public familyId: string;
	@Input() public description: string;
	@Input() public groupId: string;
	@Input() public category: string;
	@Input() public searchText: string;
	@Input() public familyType: string;
	@Input() public modelIdsList: string[];
	@Input() public selectedFilters: Array<ModelsExperienceFilters> = [];
	@Input() public isAuthenticated: boolean = false;
	@Input() public selectedModelsToCompare: Array<ModelListRow> = [];

	@Output() public readonly selectedModels: EventEmitter<Array<ModelListRow>> = new EventEmitter<Array<ModelListRow>>();
	public appPaths = ApplicationPathConstants.MODELS_BROWSE_PATHS;
	public containsData: boolean = false;
	public customAdvisoryFee$: Observable<number>;
	public familyAladdinTicker$: Observable<string>;
	public readonly blkFamilyGroup = SharedApplicationConstants.MODEL_FAMILY.BLACKROCK_FAMILY_GROUP;

	constructor(private applicationStateStoreProxyService: ApplicationStateStoreProxyService, private modelsBrowseDataService: ModelsBrowseDataService) { }

	public ngOnInit(): void {
		const overviewData = get(this.data.getTabById('overview'), 'tableData[0].rows', []);
		const modelData = get(this.data.getTabById('model.list'), 'tableData[0].rows', []);
		this.containsData = !isEmpty(overviewData) || !isEmpty(modelData);
		this.familyAladdinTicker$ = this.modelsBrowseDataService.getAladdinTicker(this.familyId);
		this.customAdvisoryFee$ = this.applicationStateStoreProxyService.getPerformanceState()
			.pipe(
				untilDestroyed(this),
				map((state: PerformanceState) => {
					return state.customAdvisoryFee;
				}));
	}
}
